import React, { useState, useEffect } from "react";
import Api from "../libraries/api";

export default (url) => {
  const [status, setStatus] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();

    setLoading(true);
    Api.get(url)
      .then((res) => {
        if(res.data && res.data.data && res.data.data.length){
          let tmpStatus = {};
          res.data.data.map(x=>{
            if(x.reservations_status){
              tmpStatus[x.reservations_status] = true;
            }
          });
          // console.log('tmpStatus',tmpStatus)
        }
        setData(res.data);
        setLoading(false);
        setStatus(true);
      })
      .catch((e) => {
        setLoading(false);
        setStatus(false);
        setError(e);
      });

    return () => {
      abortController.abort();
    };
  }, [url]);

  return { status, data, isLoading, error };
};
